import { useState, useEffect } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { HiArrowUp, HiCalendar } from 'react-icons/hi';
import Header from './Header';
import Footer from './Footer';
import siteContent from '../../data/siteContent.json';

export default function Layout() {
  const [showFloatingCTA, setShowFloatingCTA] = useState(false);
  const [showBackToTop, setShowBackToTop] = useState(false);
  const location = useLocation();

  // Don't show floating CTA on booking page
  const isBookingPage = location.pathname === '/book';

  useEffect(() => {
    const handleScroll = () => {
      const scrollY = window.scrollY;

      // Show floating CTA after scrolling 500px
      setShowFloatingCTA(scrollY > 500);

      // Show back to top after scrolling 1000px
      setShowBackToTop(scrollY > 1000);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <div className="min-h-screen flex flex-col">
      <Header />
      <main className="flex-grow">
        <Outlet />
      </main>
      <Footer />

      {/* Floating Mobile CTA */}
      {!isBookingPage && (
        <a
          href={siteContent.social.linktree}
          target="_blank"
          rel="noopener noreferrer"
          className={`floating-cta lg:hidden flex items-center gap-2 px-6 py-3 bg-dusty-rose text-chalk text-xs font-bold uppercase tracking-widest rounded shadow-2xl transition-all duration-500 hover:bg-dusty-rose/90 ${showFloatingCTA ? '' : 'hidden-cta'}`}
          aria-label="Book Now"
        >
          <HiCalendar className="h-4 w-4" />
          Book Now
        </a>
      )}

      {/* Back to Top Button */}
      <button
        onClick={scrollToTop}
        className={`back-to-top ${showBackToTop ? '' : 'hidden-btn'}`}
        aria-label="Back to top"
      >
        <HiArrowUp className="h-5 w-5" />
      </button>
    </div>
  );
}
